const INIFINITY = 10000000;

jQuery(document).ready(($) => {
    function postArticleStats(postId, data) {
        // return new Promise((resolve, reject) => {
            data.mobile = $(window).width() < 600;
            data.desktop = ! data.mobile;
            $.ajax({
                url: `/wp-json/article/stats/${postId}`,
                type: "POST",
                data: JSON.stringify(data),
                contentType: "application/json",
                // complete: resolve,
                // error: reject,
                async: false
            });
            data.spendTime = 0;
        // });
    }

    // let $profiler = $('<div style="position: fixed; bottom: 0; right: 0; background: #808080; padding: 1em; font-size: 18px;"></div>')
    // let $debugInput = $('<input style="width: 100%;" type="text" value="2e278166-0b48-4f7d-8248-25b77be08039" />')
    // let $debug = $('<div>Debug</div>')
    // let $style = $('<style type="text/css"></style>')
    // // $profiler.append($debugInput)
    // $profiler.append($debug)
    // $('body').append($profiler)
    // $('head').append($style)

    function SimpleComponent($element){
        const $el = $element
        const uuid = $el.data('component-id');
        const type = $el.data('component-type');
        let progress = 0;

        function getProgress(){
            let currentProgress = $el.height() > 0 ? ($(window).scrollTop() + $(window).height() - $el.offset().top) / $el.outerHeight() : 0;
            currentProgress = Math.min(Math.max(currentProgress, 0), 1)
            if(currentProgress > progress){
                progress = currentProgress
            }

            // $style.html(`[data-component-id="${$debugInput.val()}"]{ background: #800000; }`)
            // if(uuid === $debugInput.val()){
            //     $debug.html(`Scroll top: ${$(window).scrollTop()} <br/>`)
            //     $debug.append(`Window height: ${$(window).height()} <br/>`)
            //     $debug.append(`Offset element: ${$el.offset().top} <br/>`)
            //     $debug.append(`Height element: ${$el.outerHeight()} <br/>`)
            //     $debug.append(`Scroll bottom to element: ${($(window).scrollTop() + $(window).height() - $el.offset().top)} <br/>`)
            //     $debug.append(`Progress: ${currentProgress} <br/>`)
            // }

            return progress;
        }

        this.getUuid = () => uuid;
        this.getElement = () => $el;
        this.getData = () => ({
            uuid,
            progress: getProgress(),
        })
        getProgress();
    }

    function SliderComponent($element){
        const $el = $element
        const uuid = $el.data('component-id');
        const type = $el.data('component-type');
        let progress = 0;

        const $slinder = $el.find('.slider__wrapper').length ? $el.find('.slider__wrapper') : $el.find('.slideshow-wrapper')
        if($slinder.attr('data-slide-count') > 0){
            progress = 1 / parseInt($slinder.attr('data-slide-count'))
        }
        $slinder.on('slider-index-changed', (e) => {
            const newProgress = e.tinySliderInfo.index / e.tinySliderInfo.slideCount
            if(newProgress > progress){
                progress = newProgress
            }
        })

        this.getUuid = () => uuid;
        this.getElement = () => $el;
        this.getData = () => ({
            uuid,
            progress,
        })
    }

    function VideoComponent($element){
        const $el = $element
        const uuid = $el.data('component-id');
        const type = $el.data('component-type');
        let progress = 0;

        let $video = $element.find('video')
        function getProgress(){
            const newProgress = $video[0].currentTime / $video[0].duration
            if(newProgress > progress){
                progress = newProgress
            }
            return progress;
        }

        $video.on('pause', (e) => {
            getProgress()
        })

        this.getUuid = () => uuid;
        this.getElement = () => $el;
        this.getData = () => ({
            uuid,
            progress: getProgress()
        })
    }

    function createComponent($el){
        const type = $el.data('component-type');
        switch (type){
            case 'text':
            case 'image':
            case 'table':
                return new SimpleComponent($el);

            case 'slider':
            case 'quiz':
                return new SliderComponent($el);
            case 'video':
                return new VideoComponent($el);

        }
    }

    $('[data-single-article]').each(function (){
        const $singleArticle = $(this);
        const postId = $singleArticle.data('single-article');
        const data = {
            mobile: false,
            desktop: false,
            articleComponentsStatistics: [],
            spendTime: 0
        };
        let timerHandler = setInterval(() => {
            data.spendTime += 1;
        }, 1000);
        let periodSendHandler = setInterval(async () => {
            update()
            postArticleStats(postId, data)
        }, 30000)
        $(window).on('beforeunload', () => {
            update()
            postArticleStats(postId, data)
            return undefined;
        })

        const components = [];

        $singleArticle.find('[data-component-id]').each(function (){
            components.push(createComponent($(this)))
        })

        function update(){
            data.articleComponentsStatistics = components.map((component) => component.getData())
        }

        function resize(){
            components.forEach((component) => {
                component.resize()
            })
            data.articleComponentsStatistics = components.map((component) => component.getData())
        }

        // let temp;
        // function delayRun(callback){
        //     if(temp){
        //         clearTimeout(temp)
        //     }
        //     temp = setTimeout(callback, 1000)
        // }

        $(window).scroll(function (){
            update();
        })
        $(window).resize(function (){
            update();
        })
    })
})